import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppShell } from './components/AppShell';
import { LoginPage } from './pages/Login/LoginPage';
import './App.css';

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      {/* unstable_useTransitions={false} — React Router 7 wraps every location
          update in React.startTransition by default. With a heavy AgGrid on
          the OLD route, the concurrent renderer keeps yielding back to the
          old tree's continuous rAF work and never commits the new tree;
          the URL changes but the screen never switches until an urgent update
          (a scroll, a dialog) flushes the pending transition. Opting out
          makes navigation synchronous — exactly what we want for a desktop
          banking UI. */}
      <BrowserRouter unstable_useTransitions={false}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            {/* AppShell owns everything past /login. It no longer has nested
                <Route> children here — internal-tabs keep-alive (plan §3.3)
                needs AppShell to render its OWN <Routes location={tab.location}>
                per open tab (see TabHost), so the outer router only needs to
                hand it the whole subtree via path="/*". The actual page
                <Route> elements live in src/appRoutes.tsx and are matched
                again, once per tab, inside AppShell. */}
            <Route path="/*" element={<AppShell />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
